import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Config, Log, CommonService,/*, JwtHelper*/
Logout} from 'huddyapi';
import { map } from 'rxjs/operators';
import { DesktopStorageService } from './storage.service';
import { SocialUser, SocialAuthService } from '@abacritt/angularx-social-login';
import { Store } from '@ngxs/store';
import { Router } from '@angular/router';


@Injectable()
export class TempAuthService {

  constructor(
    public router: Router,
    private http: HttpClient,
    private storage: DesktopStorageService,
    private commonService: CommonService,
    private storageService: DesktopStorageService,
    private config: Config,
    private store: Store,
    private socialAuthService: SocialAuthService
    ) {}

  public authenticate(credentials: Credentials, canRegister: boolean = true) {
    const headers: HttpHeaders = new HttpHeaders().append('allowDupes', 'true').append('canRegister', canRegister.toString());
    return this.http.post(this.config.getEndpoint() + '/authenticate', credentials, { headers: headers, observe: 'response' })
      .pipe(map((response: any) => {
        Log.logClassLevel(0, 'auth service, success', response);
        this.authenticateSuccess(response, credentials);
        return 'Bearer ' + response.body.id_token;
      }, (error: any) => {
        this.authenticateFailure(error);
      }));
  }


  public authenticateSuccess (response: HttpResponse<any>, credentials: Credentials) {
    Log.logClassLevel(0, 'AuthService',"in authenticateSuccess");

    Log.logClassLevel(0, 'AuthService',response );

    var bearerToken = 'Bearer ' + response.body.id_token;
    //Log.logClassLevel(0, 'AuthService',"bearerToken=" + bearerToken);
    if (bearerToken) {
      Log.logClassLevel(0, 'AuthService',"Setting jwt does it already exist?=" + (null != CommonService.jwt));
      CommonService.setJWT(bearerToken);
      if(credentials.rememberMe)
        this.storage.set('jwt', bearerToken);
      this.storage.set('hasLoggedIn', 'true');
      CommonService.setLoggedOut(false);
      /*
      if (response.headers.has('shouldReset'))
        return "shouldReset";
      */
      CommonService.justRegistered = response.headers.has('justRegistered');
      Log.logClassLevel(0, 'AuthService',"attempting from auth");

      return this.commonService.refreshCurrentUser(bearerToken, true);
    } else {
      Log.logClassLevel(0, 'AuthService',bearerToken);
      Log.logClassLevel(0, 'AuthService','Not defining profile');
      return null;
    }

  }

  public authenticateFailure (data) {
   Log.logClassLevel(0, 'AuthService',"in authenticateFailure");
    Log.logClassLevel(0, 'AuthService',data);
    var msg : string = "failure " + data.AuthenticationException;

    Log.logClassLevel(0, 'AuthService',"status=" + data.status);
    Log.logClassLevel(0, 'AuthService',"headers=" + data.headers);
    if (msg)
      return msg;
    else
      return "failure";
  }

  public authenticated() {
    //return tokenNotExpired('jwt');
    var token = CommonService.jwt;
    // Log.logClassLevel(0, 'AuthService',"TOKEN=" + token);
    return token != null;
    // const jwtHelper = new JwtHelper();
    // return token != null && !jwtHelper.isTokenExpired(token);
  }

  public verifyAccount(data: any) {
    const headers: HttpHeaders = new HttpHeaders().append('allowDupes', 'true');
    return this.http.post(this.config.getEndpoint() + '/verify', data, { headers: headers })
    .pipe(map((response: any) => {
      return response;
    }, (error: any) => {
      throw error;
    }));
  }

  public getNewVerificationCode(data: any) {
    const headers: HttpHeaders = new HttpHeaders().append('allowDupes', 'true');
    return this.http.post(this.config.getEndpoint() + '/verificationCode', data, { responseType: 'text', headers: headers }).pipe(map((response: any) => {
      return response;
    }, (error: any) => {
      throw error;
    }));
  }

  public getAccount(token: string) {
    const headers: HttpHeaders = new HttpHeaders().append('Authorization', token);
    return this.http.get(this.config.getEndpoint() + '/account', { headers: headers }).pipe(map((response: any) => {
      return response;
    }, (error: any) => {
      throw error;
    }));
  }

  public login(credentials: Credentials, canRegister: boolean = true): Promise<any> {
    return this.authenticate(credentials, canRegister).toPromise().then((token: any) => {
      return this.getAccount(token).toPromise().then((user: any) => {
        Log.logClassLevel(0, "AuthService", user);
        CommonService.setUserAuth(token, user.email, user);
        Log.logClassLevel(1, "Auth Service", user.email)
        if(credentials.rememberMe == null)
          credentials.rememberMe = false;
        let promises = [
          this.storageService.set('email', user.email, credentials.rememberMe),
          this.storageService.set('Trusted-User', user.email, credentials.rememberMe),
          this.storageService.set('jwt', token, credentials.rememberMe)
        ];
        return Promise.all(promises).then(() => {
          return user;
        }, (error: any) => {
          throw error;
        });
      }, (error: any) => {
        throw error;
      });
    }, (error: any) => {
      throw error;
    });
  }

  public socialLogin(user: SocialUser, uuid: string): Promise<any> { //on logout it should check if the socialAuthService is logged in, and if so it should log out
    return this.login(new Credentials({
      username: user.email,
      password: user.email,
      rememberMe: false,
      deviceUUID: uuid,
      deviceToken: uuid,
      firebaseToken: user.idToken,
      photoURL: user.photoUrl
    }));
  }

  public googleLogin(firebaseUser: any, idToken: string, uuid: string, canRegister: boolean = true) {
    return this.login(new Credentials({
      username: firebaseUser.user.email,
      password: firebaseUser.user.email,
      rememberMe: false,
      deviceUUID: uuid,
      deviceToken: uuid,
      firebaseToken: idToken,
      photoURL: firebaseUser.user.photoUrl
    }), canRegister);
  }

  public anonymousLogin(uuid: string): Promise<any> {
    return this.login(new Credentials({
      username: '',
      password: '',
      rememberMe: false,
      isBrowser: false,
      deviceUUID: uuid,
      deviceToken: uuid
    }));
  }

  public logOut(navigate: boolean = true): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      CommonService.setUserAuth(null, null, null);
      Promise.all([
        this.storageService.remove('jwt'),
        this.storageService.remove('email'),
        this.storageService.remove('Trusted-User')
      ]).then(() => {
        this.socialAuthService.signOut().finally(async () => {
          let rejected: boolean = false;
          if(navigate) {
            await this.router.navigate(['']).then((succeeded: boolean) => {
              if(!succeeded) {
                rejected = true;
                reject('Navigation failed');
              }
            }, (error: any) => {
              rejected = true;
              reject(error);
            });
          }
          this.store.dispatch(new Logout()).subscribe(() => {
            resolve();
          }, (error: any) => reject(error));
        });
      }, (error: any) => reject(error));
    });
  }
}

export class Credentials {
  username: string;
  password: string;
  deviceUUID: string;
  rememberMe: boolean;
  newEmail: any;
  deviceToken: string;
  firebaseToken: string;
  photoURL: string;

  constructor(obj: any) {
    this.username = obj.username;
    this.password = obj.password;
    this.deviceUUID = obj.deviceUUID;
    this.rememberMe = obj.rememberMe;
    this.newEmail = obj.newEmail;
    this.deviceToken = obj.deviceToken;
    this.firebaseToken = obj.firebaseToken;
    this.photoURL = obj.photoURL;
  }
}
